import { render, staticRenderFns } from "./TranzilaType.vue?vue&type=template&id=49f287fe&"
import script from "./TranzilaType.vue?vue&type=script&lang=ts&"
export * from "./TranzilaType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports